// import { getConfigDetails } from '../services/config'

import { getConfigDetails } from '../../../services/config'

export const APICONFIG = {

	singInUrl: `${getConfigDetails().baseURL}oauth/access_token`,
	singupUrl: `${getConfigDetails().baseURL}sign-up`,
	sendEmailResetPassword: `${getConfigDetails().baseURL}user/reset-password/email`,

	// pave ungated get faclity Data
	getFaclityUrl: `${getConfigDetails().baseURL}pave-web-get-facility-rate`,

	// pave ungated get faclity Data by Rate Band
	getFaclityRateUrl: `${getConfigDetails().baseURL}get-facility-rate`,

	postUrlForPayment: `${getConfigDetails().baseURL}pave-make-web-ungated-checkin-payment`,
	postWarningUrlForPayment: `${getConfigDetails().baseURL}enforcement-ungated-checkin-payment`,

	// main-street 
	getFaciltyUrl: `${getConfigDetails().baseURL}get-facility`,
	// add card Details
	postCardDetails: `${getConfigDetails().baseURL}transient-make-payment`,
	// extend Page 
	getExtendDetails: `${getConfigDetails().baseURL}pave-extend-payment-details`,
	postExtendDays: `${getConfigDetails().baseURL}pave-days-amount`,
	// postExtendDays: `${getConfigDetails().baseURL}get-extend-rate-checkin-details`,
	postExtendSubmit: `${getConfigDetails().baseURL}pave-make-extend-payment`,



	ticketValidateUrl: `${getConfigDetails()?.baseURL}validate-qrbased-ticket`,
	getSearchUrl: `${getConfigDetails()?.baseURL}ticket-search`,
	getUserDetailUrl: `${getConfigDetails()?.baseURL}search-ticket-number`,
	sendSmsEmailUrl: `${getConfigDetails()?.baseURL}send-sms-email`,
	downloadTicketUrl: `${getConfigDetails()?.baseURL}download-ticket-details`,
	getPartnerDetails: `${getConfigDetails()?.baseURL}partners-key-by-secret/${getConfigDetails()?.CLIENT_SECRET}`,
	getSearchTicketUrl: `${getConfigDetails()?.baseURL}get-receipt-ticket-details`,
	downloadEticketUrl: `${getConfigDetails()?.baseURL}download-receipt-pdfticket`,

	// End Current Parking
	endParking: `${getConfigDetails()?.baseURL}pave-end-session`,

	// Passowrd Reset
	resetPassword: `${getConfigDetails()?.baseURL}user/reset-password`,
	// UPDATED USER PROFILE
	updateUserProfileUrl: `${getConfigDetails().baseURL}diamond-update-profile`,

	// Get user profile
	getUserProfileUrl: `${getConfigDetails().baseURL}diamond-get-user-by-id`,

	// Reset Password
	postRestPassword: `${getConfigDetails().baseURL}reset-are-password`,


	//apply-promocode-on-ticket
	applyPromoCode: `${getConfigDetails()?.baseURL}apply-promocode-on-ticket`,

	//apply-promocode-on-ticket
	applyReservationID: `${getConfigDetails()?.baseURL}validate-reservation`,

	// GET EXTEND LIST
	getExtendList: `${getConfigDetails()?.baseURL}get-ticket-extend-list`,


	// get-vehicle

	getVehicleList: `${getConfigDetails()?.baseURL}get-vehicle`,
	addVehilceUrl: `${getConfigDetails()?.baseURL}add-vehicles`,
	editVehilceUrl: `${getConfigDetails()?.baseURL}edit-vehicle`,
	deleteVehilceUrl: `${getConfigDetails()?.baseURL}delete-vehicle`,
	getVehicleModelUrl : `${getConfigDetails().baseURL}get-all-make-models`,


	// update password and profile
	updateProfile: `${getConfigDetails()?.baseURL}update-profile`,
	newresetPassword: `${getConfigDetails()?.baseURL}user`,

	// CARDS APIS
	getCardLists: `${getConfigDetails()?.baseURL}get-card-profile`,
	addCard: `${getConfigDetails()?.baseURL}add-card-profile`,
	deleteCard: `${getConfigDetails()?.baseURL}delete-card-profile`,

	// RECEIPTS

	getReceipts: `${getConfigDetails()?.baseURL}get-user-checkin-history/page/`,

	// Receipt Api
	receiptlistApi: `${getConfigDetails()?.baseURL}get-user-checkin-history/page/`,

	// STORE EVENT LOG
	storeEventLog: `${getConfigDetails()?.baseURL}addUserEvent`,

	// STORE EVENT LOG
	checkActiveSession: `${getConfigDetails()?.baseURL}customerapp-facility-details`,

	// faclity on marker 
	faclityOnMarker: `${getConfigDetails().baseURL}rate/facility-on-marker`,

	// GET SERVICE URL
	getServicePageUrl: `${getConfigDetails().baseURL}pave-faq-term-condition`,

	// FETCH RATE BANDS
	getRateBands: `${getConfigDetails().baseURL}pave-price-band`,


	// GET PARTNER DETAILS BY SLUG
	getPartnerBySlug: `${getConfigDetails().baseURL}partner-details-by-slug`,


	// Fetch Rate Details
	getFetchRates: `${getConfigDetails().baseURL}rate-details/`,

	getPermitTypeByEMailURL: `${getConfigDetails()?.baseURL}get-permit-rate-by-email`,



}
